import { Map, fromJS } from 'immutable'
import { PERSONALITY_SAGE_ID } from 'services/oracle'
import * as actions from './actions'

export const initialState = Map({
  persona: PERSONALITY_SAGE_ID,
  accessError: null,
  guideOnSideClosed: true, // false = open, true = closed
  guideEnabled: false, // true = user passes Gaia config + PostHog experiment flags
  toastNudgeDismissedContentId: null, // contentId for which the toast was dismissed
  // Future: pin state will be local to component, not in Redux
})

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case actions.SET_ORACLE_PERSONA:
      return state.set('persona', action.payload.persona)
    case actions.SET_ORACLE_ACCESS_PROCESSING:
      return state.set('accessProcessing', action.payload.processing)
    case actions.SET_ORACLE_ACCESS:
      return state
        .set('access', fromJS(action.payload.access))
        .set('accessProcessing', action.payload.processing)
        .set('accessError', null) // Clear error on successful access
    case actions.SET_ORACLE_ACCESS_ERROR:
      return state
        .set('accessError', fromJS(action.payload.error))
        .set('accessProcessing', false)
    case actions.SET_ORACLE_GUIDE_ON_SIDE_CLOSED:
      return state.set('guideOnSideClosed', action.payload.closed)
    case actions.SET_ORACLE_GUIDE_ENABLED:
      return state.set('guideEnabled', action.payload.enabled)
    case actions.SET_ORACLE_GUIDE_TOAST_DISMISSED:
      return state.set('toastNudgeDismissedContentId', action.payload.contentId)
    // TODO: Future - pin/unpin functionality (commented for v1)
    // case actions.SET_ORACLE_GUIDE_ON_SIDE_STATE:
    //   return state.set('guideOnSideState', action.payload.state)
    default:
      return state
  }
}
